<template>
    <div style="text-align: center">
        <c-customer-select
            :label  = "$t('unit.bulkupdate.customer.select')"
            v-model = "customer"
            hide-details
        />
        <v-btn
            :disabled = "!customer"
            color     = "primary"
            class     = "dialog-button mt-8"
            @click    = "onUpdate"
            rounded
        >
            {{ $t('unit.bulkupdate.command') }}
        </v-btn>
    </div>
</template>

<script>


import Core            from "@/modules/core/service/Core";
import Site            from "@/modules/msd/unit/service/Site";
import CCustomerSelect from "@/modules/msd/company/customer/components/controlls/CCustomerSelect.vue";

export default {
    name: "CCustomerBulkUpdateChangeCustomer",

    components: {
        CCustomerSelect
    },

    props: {
        units: {

        }
    },

    data: () => ({
        show: false,
        customer: null,
    }),

    mounted() {
        this.show = this.value;
    },

    watch: {
        value () {
            this.show = this.value;
        }
    },

    methods: {
        load () {
        },

        onUpdate () {
            Core.message.confirm(
                this,
                this.$t('unit.bulkupdate.customer.confirm.query'),
                this.$t('unit.bulkupdate.customer.confirm.text', [ this.customer.name, this.units.length ]),
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }

                    Site.update.bulk(this.units, this.customer).then (() => {
                        this.$emit("done")
                    });
                });
        },

        onCancel () {
            this.$emit("input", false);
        },
    }
}
</script>

<style scoped>

.close-button {
    position: absolute;
    z-index: 10;
    right: 16px;
    top: 20px;
}

</style>